export { getSignUpInitialFields } from './initialFields';
export { getInitialPhoneNumberStep, getCheckingPhoneNumberStep } from './phoneNumber';
export { GetPlainSignUpSteps } from './steps';
